import React from 'react'
import { Box } from '@usap/uicomponents'
import { SidebarText } from './StyledCSS'
import useGetLifetimeReplacementFlag from '../MyAccount/RMA/hooks/useGetLifetimeReplacementFlag'
import { StaticSidebarInnerContainer, StaticSidebarMainContainer } from './style/StaticSidebar.css'

export default function StaticSidebar({ pageType, Link = () => '', records, loggedIn }) {
  const isLifetimeReplacement = useGetLifetimeReplacementFlag()
  let notAllowed = []
  if (!isLifetimeReplacement) {
    notAllowed = ['Lifetime Replacement Guarantee']
  }

  const sideLinks = records.filter(rec => !notAllowed.includes(rec.text)).map(item => {
    if (item.text === 'Track Order' && !loggedIn) {
      return { ...item, link: '/customer/trackorder' }
    }
    return item
  })


  return (
    <StaticSidebarMainContainer>
      <Box responsive={false} pad="small" justify="center">
        <StaticSidebarInnerContainer gap="medium">
          {sideLinks.map(value => (
            <Link key={value.text} to={value.link}>
              <SidebarText
                staticSidebar
                size="small"
                color={pageType === value.pageType ? 'neutral-3' : 'dark-2'}
                weight={pageType === value.pageType ? 'bold' : 'normal'}
              >
                {value.text}
              </SidebarText>
            </Link>
          ))}
        </StaticSidebarInnerContainer>
      </Box>
    </StaticSidebarMainContainer>
  )
}
